const JamaicaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111662)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M32.1768 4.13437C28.8044 1.54211 24.5829 0 20.0005 0C15.4182 0 11.1966 1.54219 7.82422 4.13437L20.0005 16.3106L32.1768 4.13437Z"
        fill="#6DA544"
      />
      <path
        d="M4.1343 7.82324C1.54219 11.1957 0 15.4171 0 19.9995C0 24.5818 1.54219 28.8034 4.13437 32.1759L16.3107 19.9995L4.1343 7.82324Z"
        fill="black"
      />
      <path
        d="M7.82422 35.8657C11.1967 38.458 15.4182 40.0001 20.0005 40.0001C24.5829 40.0001 28.8044 38.4579 32.1769 35.8657L20.0005 23.6895L7.82422 35.8657Z"
        fill="#6DA544"
      />
      <path
        d="M35.8657 32.1757C38.458 28.8033 40.0001 24.5818 40.0001 19.9995C40.0001 15.4171 38.458 11.1957 35.8657 7.82324L23.6895 19.9995L35.8657 32.1757Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111662">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default JamaicaSvg;
